@if (form) {
  <div class="modalForm" [formGroup]="form">
    <div class="flex flex-column gap-2 mb-3">
      <label for="firstName" class="font-semibold">{{ "gate_administration.user_list.first_name" | translate }}*</label>
      <input pInputText id="firstName" formControlName="firstName" autocomplete="off" />
    </div>
    <div class="flex flex-column gap-2 mb-3">
      <label for="lastName" class="font-semibold">{{ "gate_administration.user_list.last_name" | translate }}*</label>
      <input pInputText id="lastName" formControlName="lastName" autocomplete="off" />
    </div>
    <div class="flex flex-column gap-2 mb-3">
      <label for="email" class="font-semibold">{{ "gate_administration.user_list.email" | translate }}*</label>
      <input pInputText id="email" formControlName="email" autocomplete="off" />
    </div>
    <div class="flex flex-column gap-2 mb-3">
      <label for="phone" class="font-semibold">{{ "gate_administration.user_list.phone" | translate }}</label>
      <input pInputText id="phone" formControlName="phone" autocomplete="off" />
    </div>
    <div class="flex flex-column gap-2 mb-3">
      <label for="role" class="font-semibold">{{ "gate_administration.user_list.role" | translate }}*</label>
      <p-select
        formControlName="role"
        [options]="roles()"
        optionValue="label"
        class="w-full"
        [placeholder]="translate.instant('gate_administration.user_list.role')"
        ><ng-template let-role #item>
          <span>{{ (role.label ? role.label : "") | translate }}</span>
        </ng-template>
        <ng-template let-role #selectedItem>
          <span>{{ (role.label ? role.label : "") | translate }}</span>
        </ng-template>
      </p-select>
    </div>
    <div class="flex flex-column gap-2 mb-3">
      <label class="font-semibold w-full" for="faultListPermission"
        >{{ "wiki.access_levels.form_title" | translate }}*</label
      >
      <p-select
        name="faultListPermission"
        formControlName="faultListPermission"
        autoWidth="false"
        [options]="wikiLevelOptions"
        [style]="{ width: '100%' }"
        [placeholder]="translate.instant('wiki.access_levels.form_placeholder')"
        appendTo="body"
      >
        <ng-template let-wikiLevelOption #item>
          <span>{{ (wikiLevelOption.label ? wikiLevelOption.label : "") | translate }}</span>
        </ng-template>
        <ng-template let-wikiLevelOption #selectedItem>
          <span>{{ (wikiLevelOption.label ? wikiLevelOption.label : "") | translate }}</span>
        </ng-template>
      </p-select>
    </div>
    <!-- 2FA is missing in Login component, when that is impplemented it can also be activated on user creation here: -->
    <!-- <div class="flex flex-column gap-2 mb-3">
      <label
        for="twoFactorEnabled"
        class="font-semibold flex align-items-center gap-1"
        >{{ "gate_administration.user_list.two_factor_enabled" | translate }}
        <i
          class="pi pi-info-circle"
          style="font-size: 1.5rem"
          tooltipPosition="bottom"
          [pTooltip]="
            translate.instant('gate_administration.user_list.two_factor_hint')
          "
        ></i>
      </label>
      <p-checkbox
        [value]="
          translate.instant('gate_administration.user_list.two_factor_enabled')
        "
        formControlName="twoFactorEnabled"
        inputId="twoFactorEnabled"
        [binary]="true"
      />
    </div> -->

    <div style="grid-column: 1 / 3" class="flex flex-column gap-2 mb-3">
      <label for="notes" class="font-semibold w-full">{{ "gate_administration.user_list.notes" | translate }}</label>
      <textarea rows="5" cols="30" pInputTextarea formControlName="notes" [autoResize]="true"> </textarea>
    </div>
    <div class="flex justify-content-end gap-2 dialogBtnGroup">
      <app-button [buttonText]="translate.instant('common.cancel')" (click)="ref.close()"></app-button>
      <app-button
        [loading]="requestStarted()"
        [buttonText]="translate.instant('common.save')"
        [disabled]="!form.valid || requestStarted()"
        (click)="save()"
      ></app-button>
    </div>
  </div>
}
